export default __webpack_public_path__ + "static/media/new 401.54df83bc.svg";